import { Decorative } from "@faire/design-tokens";
import { ContactUsButton } from "@faire/help-center-self-serve/components/ContactUsButton";
import { SelfServeSource } from "@faire/help-center-self-serve/consts";
import { useAIChatbotAccess } from "@faire/help-center-self-serve/hooks/useAIChatbotAccess";
import { Column, Flex, Row } from "@faire/web/slate/Layout";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var NeedMoreHelpBanner = function NeedMoreHelpBanner() {
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  var hasAIChatbotAccess = useAIChatbotAccess();
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ColorWrapper, null, /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: isMobile ? "displaySSerifRegular" : "displayMSerifRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "yfjhK+",
    defaultMessage: [{
      "type": 0,
      "value": "Need more help?"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), hasAIChatbotAccess ? ( /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "QJbK9U",
    defaultMessage: [{
      "type": 0,
      "value": "Start a chat to find answers quickly or connect with our Support team."
    }]
  }))) : ( /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "nSILmm",
    defaultMessage: [{
      "type": 0,
      "value": "Share more about your issue and get in touch with our support team."
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(StyledContactUsButton, {
    source: SelfServeSource.CONTACT_US_FOOTER_BANNER
  }))));
};
var Wrapper = styled(Column).attrs({
  justify: "center",
  align: "center"
}).withConfig({
  displayName: "NeedMoreHelpBanner__Wrapper"
})(["margin-top:", ";", "{padding:", ";}"], getSpacing("2x"), responsiveMediaQueries.tabletAndAbove, getSpacing("7x"));
var ColorWrapper = styled(Row).withConfig({
  displayName: "NeedMoreHelpBanner__ColorWrapper"
})(["background-color:", ";width:100%;max-width:1500px;", "{padding:", ";justify-content:center;}", "{padding:", ";justify-center:flex-start;}"], Decorative.tint.orange, responsiveMediaQueries.tabletAndAbove, getSpacing("7x"), responsiveMediaQueries.mobile, getSpacing("6x", "3x"));
var ContentWrapper = styled(Flex).attrs({
  direction: "column",
  align: {
    mobileAndAbove: "flex-start",
    tabletAndAbove: "center"
  }
}).withConfig({
  displayName: "NeedMoreHelpBanner__ContentWrapper"
})(["background-color:", ";"], Decorative.tint.orange);
var StyledContactUsButton = styled(ContactUsButton).attrs({
  iconDisabled: true
}).withConfig({
  displayName: "NeedMoreHelpBanner__StyledContactUsButton"
})(["width:fit-content;"]);